import type { TagSummaryJSONObject } from '@ikegps/core-api';
import type { IkeFetchable } from '@ikegps/core-shared';
import { Services } from '../services';
import { AppStore } from './index';

export class TagSummaryStore {
	// Only refetch tag summaries at most once per 10 seconds.
	static REFETCH_DELAY = 10000;
	getFetchable(tagId: string): IkeFetchable<TagSummaryJSONObject> {
		const rest = Services.Department.rest;

		const tag = AppStore.Tag.get(tagId);
		if (tag == null) {
			Services.Log.Logger.warn({ tagId }, 'Getting tag summary before tag');
			return rest.empty;
		}

		const fetchable = rest.Tag.Summary.getById(tag.objectId);

		if (fetchable.isFetching) {
			return fetchable;
		}

		if (fetchable.value == null) {
			return fetchable;
		}

		const fetchTime = Date.now() - fetchable.lastFetch;
		if (fetchTime < TagSummaryStore.REFETCH_DELAY) {
			return fetchable;
		}

		const tagUpdated = Services.DateTime.getTime(tag.updatedAt);
		if (tagUpdated < fetchable.lastFetch) {
			return fetchable;
		}

		// Looks like the tag summary is out of date force a refetch

		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		fetchable.refetch();
		return fetchable;
	}

	get(tagId: string): TagSummaryJSONObject | null {
		return AppStore.TagSummary.getFetchable(tagId).value;
	}

	clear() {
		const rest = Services.Department.rest;
		if (rest != null) {
			rest.cache.clear(rest.Objects.TagSummary);
		}
	}
}
